module.exports = __webpack_public_path__ + "static/media/question_pool.7f6e1913.jpg";